import { EChartsOption } from "echarts";

import { DataValue, FeatureImportanceSummary } from "../types";
import { FALLBACK_COLOR, NOT_AVAILABLE } from "./constants";
import { EChartsTransformer } from "./transformer";

export const residualTransformer: EChartsTransformer<FeatureImportanceSummary> = {
  transform: (fiSummary, wellData, _, __, target) => {
    if (!fiSummary) {
      return {};
    }
    const residual = fiSummary.residuals_plot;
    const targetUnitLabel = target?.Unit ? ` (${target.Unit})` : "";
    const groupMap: Record<string, { color: string; data: DataValue[] }> = {};
    residual.x.forEach((x, i) => {
      const entity = residual.entities[i];
      const color = wellData[entity]?.color || FALLBACK_COLOR;
      const group = wellData[entity]?.title || NOT_AVAILABLE;
      if (!groupMap[group]) {
        groupMap[group] = { color, data: [] };
      }
      groupMap[group].data.push({
        value: [x, residual.y[i], entity, group]
      });
    });

    const series = Object.entries(groupMap).map(([group, { color, data }]) => ({
      name: group,
      type: "scatter",
      data,
      symbolSize: 8,
      largeThreshold: 2000,
      large: true,
      itemStyle: { color },
      emphasis: { focus: "series" },
      encode: { tooltip: [0, 1] }
    }));

    return {
      animation: false,
      tooltip: {
        formatter: function (params) {
          if (!params) {
            return;
          }
          const { value } = params?.data || {};
          const entity = value.length > 2 ? value[2] : "";
          const group = value.length > 2 ? value[3] : "";
          return `<strong>${entity}</strong>
          <br/>Group: ${group}
          <br/>Predicted${targetUnitLabel}: ${value[0].toFixed(2)}
          <br/>Residual${targetUnitLabel}: ${value[1].toFixed(2)}
         `;
        }
      },
      grid: {
        top: 10,
        bottom: 25,
        left: 35,
        right: 25,
        containLabel: true
      },
      xAxis: {
        name: `Predicted Value${targetUnitLabel}`,
        type: "value",
        nameLocation: "middle",
        nameGap: 30,
        splitLine: { show: true }
      },
      yAxis: {
        name: `Residual${targetUnitLabel}`,
        type: "value",
        nameLocation: "middle",
        nameGap: 45,
        splitLine: { show: true }
      },
      dataZoom: [
        {
          type: "inside",
          xAxisIndex: 0
        },
        {
          type: "inside",
          yAxisIndex: 0
        }
      ],
      series: series
    } as EChartsOption;
  }
};
